<template lang="pug">
  .wrap
    .panel(v-loading='loading')
      h3.title Welcome to My Ethos
      h4.subtitle Please log in to get started.

      el-alert(v-if="loginError" type="error" title="Wrong email/password combination" show-icon :closable="false")

      el-form.login-form(ref="loginForm" @submit.native.prevent='onLoginSubmit' :rules="rules" :model="loginForm" label-position="top" label-width="100px" autocomplete="off")
        el-form-item(label="Email" prop="email")
          el-input(type="email" v-model.trim="loginForm.email" size='large')
        el-form-item(label="Password" prop="password" size='large')
          el-input(type="password" v-model.trim="loginForm.password" size='large')

        .form-actions
          .main-action
            el-button(type="primary" native-type='submit' size='large') Log in
          .secondary-action
            router-link(:to='{ name: "resetPassword" }')
              el-button.forgot(type='text') Forgot your password?

</template>

<script>
// import _ from 'lodash'
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", [
      "loginReturnUrl",
      "isSuperUser",
      "isActiveCompanyAdmin",
      "user",
      "activeCompany"
    ])
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      loading: false,
      loginError: false,
      rules: {
        email: [
          {
            required: true,
            type: "email",
            message: "Please enter your email",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Please enter your password",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    onLoginSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.loginError = false;
        this.$store
          .dispatch("auth/login", this.loginForm)
          .then(() => {
            this.loading = false;

            // window.Intercom('update', {
            //   user_id: this.user.id,
            //   email: this.user.email,
            //   company: _.get(this.activeCompany, 'name')
            // })

            if (this.isSuperUser) {
              this.$router.push({ name: "superAdmin:dashboard" });
              return;
            }

            if (this.isActiveCompanyAdmin) {
              this.$router.push({ name: "companyAdmin:dashboard" });
              return;
            }

            const toRoute = this.loginReturnUrl
              ? { path: this.loginReturnUrl }
              : { name: "brapp:dashboard", params: { app: "brapp" } };
            this.$store.commit("auth/setLoginReturnUrl", { url: null });
            this.$router.push(toRoute);
          })
          .catch(err => {
            if (err.response && err.response.status === 400) {
              this.loading = false;
              this.loginError = true;
            } else {
              throw err;
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/mixins.scss";
.wrap {
  height: 100%;
  background: #475669;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
}

.title {
  margin-bottom: 10px;
}

.panel {
  background: white;
  background-image: url(../../assets/images/ethos-logo.png);
  background-size: 60px;
  background-position: 50% 5%;
  padding: 80px 20px 20px 20px;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 500px;
  margin: 60px auto 0 auto;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  font-family: "gilroylight";

  h3 {
    text-align: center;
  }
  h4 {
    text-align: center;
    margin-bottom: 15px;
  }
  @include MQ(S) {
    margin-top: 20px;
  }
}

.login-form {
  margin-top: 20px;
}

label.el-form-item__label {
  font-family: "gilroyextrabold", sans-serif;
  text-transform: uppercase;
}

input {
  font-family: "Open Sans", sans-serif;
}

.forgot {
  text-transform: none;
  color: #666;
  font-size: 13px;
}

.form-actions {
  display: flex;
  vertical-align: middle;
}

#intercom-container {
  display: none;
}
</style>
